import React from 'react'
import { styled } from '@mui/material'

const Root = styled('span', {
  shouldForwardProp: (p) => p !== '$on' && p !== '$disabled',
})<{ $on?: boolean; $disabled?: boolean }>(({ $on, $disabled }) => ({
  display: 'inline-block',
  width: 42,
  height: 24,
  borderRadius: 12,
  background: $on ? 'var(--ds-accent-deep-b, #8b5cf6)' : 'var(--ds-border-strong)',
  position: 'relative',
  flexShrink: 0,
  cursor: $disabled ? 'not-allowed' : 'pointer',
  opacity: $disabled ? 0.5 : 1,
  transition: `background var(--ds-duration-fast) var(--ds-ease)`,
  '&::after': {
    content: '""',
    position: 'absolute',
    top: 2.5,
    left: 2.5,
    width: 19,
    height: 19,
    borderRadius: '50%',
    background: '#fff',
    boxShadow: 'var(--ds-shadow-soft)',
    transition: `transform var(--ds-duration-normal) var(--ds-ease)`,
    transform: $on ? 'translateX(18px)' : 'none',
  },
}))

export interface ToggleProps {
  checked?: boolean
  disabled?: boolean
  onChange?: (checked: boolean) => void
  'aria-label'?: string
}

/** Small pill switch — the design system has no Switch primitive yet, so this is local to settings. */
export function Toggle({ checked, disabled, onChange, ...rest }: ToggleProps) {
  return (
    <Root
      role='switch'
      aria-checked={checked}
      $on={checked}
      $disabled={disabled}
      onClick={disabled ? undefined : () => onChange?.(!checked)}
      {...rest}
    />
  )
}
